module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.option.id,
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.option.title))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", function() {
    return [_c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.option.body)
      }
    }), _vm._v(" "), (_vm.selectOptions || _vm.option.input) ? _c('div', {
      staticClass: "box-body form p-x-0"
    }, [(_vm.selectOptions) ? _c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n              " + _vm._s(_vm.selectOptions.name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "form-group m-0"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected),
        expression: "selected"
      }],
      staticClass: "form-control h-38",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, _vm.selectOnChange]
      }
    }, _vm._l((_vm.selectOptions.options), function(option) {
      return _c('option', {
        domProps: {
          "value": option.value
        }
      }, [_vm._v("\n                    " + _vm._s(option.text) + " "), (option.value !== null) ? _c('span', [_vm._v("(" + _vm._s(option.value) + ")")]) : _vm._e()])
    }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.option.input) ? _c('div', [_c('br'), _vm._v(" "), _c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v(_vm._s(_vm.option.input.name))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.inputValue),
        expression: "inputValue"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "",
        "type": "text"
      },
      domProps: {
        "value": (_vm.inputValue)
      },
      on: {
        "change": function($event) {
          return _vm.inputOnChange(_vm.inputValue)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.inputValue = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('br')]) : _vm._e()]) : _vm._e()]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    style: ({
      'text-align': _vm.option.footerTextAlign || 'right'
    })
  }, _vm._l((_vm.option.btns), function(btn) {
    return _c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-dismiss": "modal"
      },
      on: {
        "click": function($event) {
          return _vm.trigger(btn.event)
        }
      }
    }, [_vm._v(_vm._s(btn.name))])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2af0eb81"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/Modal.vue
// module id = 2363
// module chunks = 1